import type { JSX } from 'react';

import './SkipLink.less';

interface SkipLinkProps {
  text: string;
  target: string;
}

export const SkipLink = ({ text, target }: SkipLinkProps): JSX.Element => {
  return (
    <a className="skip-link" href={`#${target}`}>
      {text}
    </a>
  );
};
